module.exports = __webpack_public_path__ + "static/media/pt_BR.ffe90c2d.svg";